<template>
  <div>
    <el-row :gutter="20">
      <!-- 左侧：收藏类别 -->
      <el-col :span="3">
        <el-card class="list-selector">
          <ul class="list-selector-list">
            <li @click="handleCollectTypeSelect('')"
              :class="{ 'selected': staffCollectedProductInfo.conditions.collectType === '' }">
              {{ $t('staffCollectedProduct.all') }}
            </li>
            <li v-for="(item, index) in staffCollectedProductInfo.collectTypes" :key="index"
              @click="handleCollectTypeSelect(item.statusCd)"
              :class="{ 'selected': staffCollectedProductInfo.conditions.collectType === item.statusCd }">
              {{ item.name }}
            </li>
          </ul>
        </el-card>
      </el-col>

      <!-- 右侧：查询条件和表格 -->
      <el-col :span="21">
        <!-- 查询条件 -->
        <el-card class="ibox">
          <div slot="header" class="flex justify-between">
            <div>{{ $t('staffCollectedProduct.queryCondition') }}</div>
          </div>
          <div class="">
            <el-form :inline="true" :model="staffCollectedProductInfo.conditions" class="flex justify-start">
              <el-form-item>
                <el-input v-model="staffCollectedProductInfo.conditions.prodName"
                  :placeholder="$t('staffCollectedProduct.inputProdName')" clearable />
              </el-form-item>
              <el-form-item>
                <el-input v-model="staffCollectedProductInfo.conditions.barCode"
                  :placeholder="$t('staffCollectedProduct.inputBarCode')" clearable />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="small" @click="_queryStaffCollectedProductMethod">
                  <i class="el-icon-search"></i> {{ $t('common.query') }}
                </el-button>
                <el-button type="primary" size="small" @click="_resetStaffCollectedProductMethod">
                  <i class="el-icon-refresh"></i> {{ $t('common.reset') }}
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-card>

        <!-- 收藏商品表格 -->
        <el-card class="margin-top-sm">
          <div slot="header" class="flex justify-between">
            <div>{{ $t('staffCollectedProduct.collectedProducts') }}</div>
            <el-button
              v-if="staffCollectedProductInfo.conditions.collectType"
              type="primary"
              size="small"
              @click="_openAddStaffCollectedProductModal"
            >
              <i class="el-icon-plus"></i> {{ $t('common.add') }}
            </el-button>
          </div>
          <div class="">
            <el-table :data="staffCollectedProductInfo.staffCollectedProducts" border style="width: 100%">
              <el-table-column prop="cpId" :label="$t('staffCollectedProduct.cpId')" align="center" width="120" />
              <el-table-column :label="$t('staffCollectedProduct.coverPhoto')" align="center" width="80">
                <template #default="scope">
                  <el-image
                    v-if="scope.row.coverPhoto"
                    :src="scope.row.coverPhoto"
                    style="width: 50px; height: 50px; border-radius: 4px;"
                    fit="cover"
                    :preview-src-list="[scope.row.coverPhoto]"
                  >
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                  <i v-else class="el-icon-picture-outline" style="font-size: 30px; color: #ccc;"></i>
                </template>
              </el-table-column>
              <el-table-column prop="prodName" :label="$t('staffCollectedProduct.prodName')" align="center" />
              <el-table-column prop="specName" :label="$t('staffCollectedProduct.specName')" align="center" />
              <el-table-column prop="barCode" :label="$t('staffCollectedProduct.barCode')" align="center" />
              <el-table-column prop="collectType" :label="$t('staffCollectedProduct.collectType')" align="center">
                <template #default="scope">
                  {{ scope.row.collectTypeName || collectTypeNameMap[scope.row.collectType] }}
                </template>
              </el-table-column>
              <el-table-column prop="sort" :label="$t('staffCollectedProduct.sort')" align="center" width="80" />
              <el-table-column prop="createTime" :label="$t('staffCollectedProduct.createTime')" align="center" />
              <el-table-column :label="$t('common.operation')" align="center" width="100">
                <template #default="scope">
                  <el-button type="text" size="small" @click="_openDeleteStaffCollectedProductModel(scope.row)">
                    {{ $t('common.delete') }}
                  </el-button>
                </template>
              </el-table-column>
            </el-table>

            <el-pagination @current-change="handleCurrentChange" :current-page="staffCollectedProductInfo.conditions.page"
              :page-size="staffCollectedProductInfo.conditions.row" layout="total, prev, pager, next"
              :total="staffCollectedProductInfo.total" />
          </div>
        </el-card>
      </el-col>
    </el-row>

    <add-staff-collected-product ref="addStaffCollectedProduct" @refresh="_queryStaffCollectedProductMethod" />
    <delete-staff-collected-product ref="deleteStaffCollectedProduct" @refresh="_queryStaffCollectedProductMethod" />
  </div>
</template>

<script>
import { getDict } from '@/api/shop/shopApi'
import { getShopId } from '@/api/shop/shopApi'
import { queryStaffCollectedProduct } from '@/api/goods/staffCollectedProductApi'
import { getUserInfo } from '@/api/user/indexApi'
import AddStaffCollectedProduct from '@/components/goods/addStaffCollectedProduct/addStaffCollectedProduct.vue'
import DeleteStaffCollectedProduct from '@/components/goods/deleteStaffCollectedProduct/deleteStaffCollectedProduct.vue'

export default {
  name: 'StaffCollectedProduct',
  components: {
    AddStaffCollectedProduct,
    DeleteStaffCollectedProduct
  },
  data() {
    return {
      staffCollectedProductInfo: {
        staffCollectedProducts: [],
        total: 0,
        records: 1,
        collectTypes: [],
        conditions: {
          prodName: '',
          barCode: '',
          collectType: '',
          shopId: '',
          staffId: '',
          statusCd: '0',
          page: 1,
          row: 10
        }
      },
      collectTypeNameMap: {
        '1001': this.$t('staffCollectedProduct.common'),
        '2002': this.$t('staffCollectedProduct.noCode'),
        '3003': this.$t('staffCollectedProduct.weigh')
      }
    }
  },
  created() {
    this._initData()
  },
  methods: {
    async _initData() {
      await this._loadUserInfo()
      await this._listStaffCollectedProducts(1, 10)
      const { data: collectTypes } = await getDict('staff_collected_product', 'collect_type')
      this.staffCollectedProductInfo.collectTypes = collectTypes
    },
    async _loadUserInfo() {
      try {
        const user = await getUserInfo()
        this.staffCollectedProductInfo.conditions.staffId = user.userId || ''
        this.staffCollectedProductInfo.conditions.staffName = user.name || ''
      } catch (error) {
        console.error('获取用户信息失败:', error)
      }
    },
    async _listStaffCollectedProducts(page, rows) {
      this.staffCollectedProductInfo.conditions.page = page
      this.staffCollectedProductInfo.conditions.row = rows
      let shopId = await getShopId();
      this.staffCollectedProductInfo.conditions.shopId = shopId

      const params = {
        ...this.staffCollectedProductInfo.conditions,
        prodName: this.staffCollectedProductInfo.conditions.prodName.trim()
      }

      try {
        const res = await queryStaffCollectedProduct(params)
        this.staffCollectedProductInfo.total = res.total
        this.staffCollectedProductInfo.records = res.records
        this.staffCollectedProductInfo.staffCollectedProducts = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    handleCurrentChange(val) {
      this._listStaffCollectedProducts(val, this.staffCollectedProductInfo.conditions.row)
    },
    _openAddStaffCollectedProductModal() {
      const collectType = this.staffCollectedProductInfo.conditions.collectType
      this.$refs.addStaffCollectedProduct.open(collectType)
    },
    _openDeleteStaffCollectedProductModel(row) {
      this.$refs.deleteStaffCollectedProduct.open(row)
    },
    _queryStaffCollectedProductMethod() {
      this._listStaffCollectedProducts(1, this.staffCollectedProductInfo.conditions.row)
    },
    _resetStaffCollectedProductMethod() {
      this.staffCollectedProductInfo.conditions.prodName = ''
      this.staffCollectedProductInfo.conditions.barCode = ''
      this.staffCollectedProductInfo.conditions.collectType = ''
      this._listStaffCollectedProducts(1, this.staffCollectedProductInfo.conditions.row)
    },
    handleCollectTypeSelect(collectType) {
      this.staffCollectedProductInfo.conditions.collectType = collectType
      this.staffCollectedProductInfo.conditions.page = 1
      this._listStaffCollectedProducts(1, this.staffCollectedProductInfo.conditions.row)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, .1);
}

.ibox-title {
  padding: 15px 15px 7px;
  min-height: 48px;
  border-bottom: 1px solid #e7eaec;
}

.ibox-content {
  padding: 15px;
}

.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
}
</style>

